import { buildQuery } from '@calendly/http-tools';
import { I18n } from '@calendly/i18n';
import { BareButton } from '@calendly/ui/components/bare-button';
import { BodyText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { RECAP_FEATURE } from '../../../tracked_meetings/index';
import { Badge } from '../styles';
const wrapperCss = "w1hajqb4";
const Wrapper = forwardRef((props, ref) => <BareButton ref={ref} {...props} className={classNames(wrapperCss, props.className)} />);
const containerCss = "c1uet54r";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, props.className)} />;
});
export const MoreResultsButton = ({
  count,
  trackedMeetingUuid,
  query,
  handleClick
}) => {
  const url = `/app/tracked_meetings/${trackedMeetingUuid}?${buildQuery({
    feature: RECAP_FEATURE.PASSAGE_SEARCH,
    q: query
  })}`;
  const clickWrapper = e => {
    handleClick(e, url, 'click_result_transcript_expand');
  };
  return <Container onClick={clickWrapper}>
      <Wrapper>
        <BodyText size="x-small" weight="bold">
          <Badge>
            {I18n.t('publisher.meetings.search.expand_card', {
            count
          })}
          </Badge>
        </BodyText>
      </Wrapper>
    </Container>;
};

require("./more_results_button.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./more_results_button.js");